<template>
  <v-dialog scrollable v-model="$store.state.confirmMessage.confirmDialog" persistent max-width="350">
    <v-card>
      <v-card-title class="title pb-0">
        <v-icon class="pr-2" :color="type">{{icons[type]}}</v-icon>
        {{title}}
      </v-card-title>
      <v-card-text class="px-6 mt-2 subheading confirmMesgTxt text-sm-left">{{message}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-show="btCancel.show"
          color="error darken-1"
          text
          @click="$store.commit('confirmMessage/closeConfirmMessage')"
        >{{btCancel.name}}</v-btn>
        <v-btn
          v-show="btConfirm.show"
          color="green darken-1"
          text
          @click="doCallback"
        >{{btConfirm.name}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    message: String,
    title: String,
    type: String,
    callback: Function,
    btConfirm: Object,
    btCancel: Object
  },
  mounted () {},
  methods: {
    doCallback () {
      if (this.callback) {
        this.callback()
        //this.$store.commit('confirmMessage/closeConfirmMessage')
      }
      this.$store.commit('confirmMessage/closeConfirmMessage')
    }
  },
  data () {
    return {
      icons: {
        error: 'fa-solid fa-ban',
        warning: 'fal fa-exclamation-circle',
        info: 'fa-solid fa-circle-info',
        success: 'fal fa-check-circle'
      }
    }
  }
}
</script>

<style>
.confirmMesgTxt {
  border-bottom: 1px solid #eee;
}
</style>
